import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app" }

import NavBar from "./components/NavBar/NavBar.vue";
import FooterComp from '@/components/FooterComp/FooterComp.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NavBar),
    _createVNode(_component_router_view, { class: "mt-[80px]" }),
    _createVNode(FooterComp)
  ]))
}
}

})